import React from 'react';

const Spaces = () => {
    return (
	<div className="section spaces">
	    <div className="side left">
		<h3>for groups that matter the most</h3>
		<div className="description">
		    <p>For families, neighbors, student groups, teams and communities</p>
		</div>
	    </div>

	    <div className="side right">
		<div className="img img1" />
		<div className="img img2" />
		<div className="img img3" />
		<div className="img img4" />
		<div className="img img5" />
	    </div>
	</div>
    );
};

export default Spaces;